// import React from 'react';
// import multiavatar from '@multiavatar/multiavatar';

// const Avatar = ({ id }) => {
//   const avatarSvg = multiavatar(id);

//   return (
//     <div
//       dangerouslySetInnerHTML={{ __html: avatarSvg }}
//       style={{ width: '28px', height: '28px'}}
//     />
//   );
// };

// export default Avatar;

import React from "react";

const Avatar = ({ id }) => {
  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0][0].toUpperCase();
    return words[0][0].toUpperCase() + words[1][0].toUpperCase();
  };

  return (
    <div
      className="
  w-7 h-7
  flex items-center justify-center
  rounded-full
  bg-white
  text-[#0F172A]
  font-medium text-sm
  border border-[#E5D8C9]
  hover:border-[#0F172A]
  hover:bg-[#FAF6F2]
  transition-all duration-300
"
    >
      {getInitials(id)}
    </div>
  );
};

export default Avatar;